import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Bell, Sparkles, Megaphone, CalendarHeart } from "lucide-react";
import { useLang } from "@/context/LangContext";

const ICONS = { offer: Sparkles, new_service: Megaphone, update: Bell, event: CalendarHeart };

export default function NotificationCenter() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/notifications").then((r) => setItems(r.data)); }, []);

  const typeLabel = (type) => {
    const key = `nc.type_${type}`;
    const val = t(key);
    return val === key ? type.replace("_", " ") : val;
  };

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.2em] text-primary mb-2">{t("nc.eyebrow")}</div>
        <h1 className="font-heading text-3xl sm:text-4xl tracking-tighter">{t("nc.title")}</h1>
      </div>

      <div className="space-y-3">
        {items.map((n) => {
          const Ic = ICONS[n.type] || Bell;
          return (
            <Card key={n.notification_id} className="p-4 border-border/60 flex gap-4" data-testid={`notif-item-${n.notification_id}`}>
              <div className="h-10 w-10 rounded-xl bg-primary/15 text-primary flex items-center justify-center shrink-0">
                <Ic className="h-5 w-5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <div className="font-semibold">{n.title}</div>
                  <Badge variant="secondary" className="text-[10px]">{typeLabel(n.type)}</Badge>
                </div>
                <p className="text-sm text-muted-foreground mt-1">{n.body}</p>
                <div className="text-[11px] text-muted-foreground mt-2">
                  {t("nc.from")} <strong>{n.from_name}</strong> · {new Date(n.created_at).toLocaleString()}
                </div>
              </div>
            </Card>
          );
        })}
        {items.length === 0 && <p className="text-sm text-muted-foreground text-center py-12">{t("nc.empty")}</p>}
      </div>
    </div>
  );
}
